import React from 'react'

import { PermissionChecker } from '../../session'
import ControlledModal from '../../../components/modals/ControlledModal'
import EditForm from './EditForm'
import FormLoader from './_load/FormLoader'
import ModalHeader from './ModalHeader'

const EditFormModal = props => {
  return (
    <ControlledModal width="42rem" disableClickOutside {...props}>
      <PermissionChecker any={['createForm', 'editForm']}>
        <ModalHeader />
        <FormLoader>
          <EditForm />
        </FormLoader>
      </PermissionChecker>
    </ControlledModal>
  )
}

export default EditFormModal
